/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Toast_Submit_ErrorInputs */

const en_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit answer`)
};

const de_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort konnte nicht eingereicht werden`)
};

const fr_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de soumettre la réponse`)
};

const es_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar la respuesta`)
};

const it_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio della risposta non riuscito`)
};

const nl_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwoord indienen mislukt`)
};

const pl_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać odpowiedzi`)
};

const fi_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastauksen lähettäminen epäonnistui`)
};

const da_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indsende svar`)
};

const sv_interview_practice_toast_submit_error = /** @type {(inputs: Interview_Practice_Toast_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte skicka svar`)
};

/**
* | output |
* | --- |
* | "Failed to submit answer" |
*
* @param {Interview_Practice_Toast_Submit_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_toast_submit_error = /** @type {((inputs?: Interview_Practice_Toast_Submit_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Toast_Submit_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_toast_submit_error(inputs)
	if (locale === "fr") return fr_interview_practice_toast_submit_error(inputs)
	if (locale === "es") return es_interview_practice_toast_submit_error(inputs)
	if (locale === "it") return it_interview_practice_toast_submit_error(inputs)
	if (locale === "nl") return nl_interview_practice_toast_submit_error(inputs)
	if (locale === "pl") return pl_interview_practice_toast_submit_error(inputs)
	if (locale === "fi") return fi_interview_practice_toast_submit_error(inputs)
	if (locale === "da") return da_interview_practice_toast_submit_error(inputs)
	if (locale === "sv") return sv_interview_practice_toast_submit_error(inputs)
	return en_interview_practice_toast_submit_error(inputs)
});